var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 18.3333V15.8333C6.66675 14.262 6.66675 13.4763 7.15491 12.9882C7.64306 12.5 8.42875 12.5 10.0001 12.5C11.5714 12.5 12.3571 12.5 12.8452 12.9882C13.3334 13.4763 13.3334 14.262 13.3334 15.8333V18.3333",
    stroke: "#2D3036",
    strokeWidth: 1.67,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 5.83301H11.6666",
    stroke: "#2D3036",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.88233C2.5 6.06865 2.5 4.16179 3.65562 2.95361C3.69831 2.90898 3.74198 2.8653 3.78662 2.82261C4.9948 1.66699 6.90166 1.66699 10.7153 1.66699C11.6192 1.66699 12.0546 1.67013 12.469 1.82479C12.8681 1.97374 13.2024 2.25232 13.871 2.80948L15.7009 4.33443C16.5856 5.07167 17.0279 5.44028 17.264 5.94421C17.5 6.44813 17.5 7.02393 17.5 8.17553V10.8337C17.5 13.9584 17.5 15.5208 16.7042 16.6161C16.4472 16.9698 16.1362 17.2809 15.7824 17.5379C14.6872 18.3337 13.1247 18.3337 10 18.3337C6.87522 18.3337 5.31283 18.3337 4.21756 17.5379C3.86383 17.2809 3.55276 16.9698 3.29576 16.6161C2.5 15.5208 2.5 13.9584 2.5 10.8337V9.88233Z",
    stroke: "#2D3036",
    strokeWidth: 1.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselDraft);
export default __webpack_public_path__ + "static/media/carousel-draft.ec443dd1ff08db3e6ecb2715e9de4be4.svg";
export { ForwardRef as ReactComponent };